/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Notifications_Job_CompletionInputs */



/**
* | output |
* | --- |
* | "Job Completion Report" |
*
* @param {Options_Notifications_Job_CompletionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_notifications_job_completion = /** @type {((inputs?: Options_Notifications_Job_CompletionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Notifications_Job_CompletionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Rapport de fin de tâche")
	if (locale === "de") return /** @type {LocalizedString} */ ("Arbeitsabschlussbericht")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rapporto di completamento del lavoro")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Отчет о завершении работ")
	if (locale === "es") return /** @type {LocalizedString} */ ("Informe de finalización del trabajo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("工作完成报告")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ジョブ完了レポート")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कार्य पूर्णता रिपोर्ट")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Relatório de Conclusão de Trabalho")
	return /** @type {LocalizedString} */ ("Job Completion Report")
});